import {msg} from "@/i18n/Message.ts";

const AS_PREFIX = "autosave.";
const DATE_CLEAN_LIMIT = (24*60*60*1000)*2; // two days
/**
 * Function to autosave text components, only CKEditor/TextArea supported now
 */
export function registerAutoSave(elementId, rowObjectClass, primaryKey, timestamp)
{
	CKEDITOR.instances[elementId].on( 'instanceReady', function( evt ) {
		const storageKey = toStorageKey(elementId, rowObjectClass, primaryKey);
		checkLocalValue(elementId, storageKey, timestamp);
		setInterval( function() { save(storageKey, elementId); }, 20000);
		//console.log( 'Total bytes: ' + evt.editor.getData().length );
	});
}

/**
 * clean items in localStorage from JsonObject
 * @param {type} jsonObject - JsonObject with array items"
 * @returns {undefined} nothing
 */
export function cleanAutoSaveItem(jsonObject)
{
	if (jsonObject!==null) {
		for (let i in jsonObject.items) {
			removeValue(jsonObject.items[i]);
		}
	}
}

export function cleanLocalStorage() {
	let now = Date.now();
	for (let i = 0; i < localStorage.length; i++) {
		let storageKey = localStorage.key(i);
		if (storageKey.startsWith(AS_PREFIX)) {
			let savedValue = getValue(storageKey);
			if (savedValue !== null && savedValue.timestamp+DATE_CLEAN_LIMIT<now) {
				console.log("Automatic removed timeout item:"+storageKey);
				removeValue(storageKey);
			}
		}
		else if (storageKey.includes("_tempDataText_") ||
				storageKey.includes("_description_") ||
				storageKey.includes("_body_") ||
				storageKey.includes("_bodyText_") ||
				storageKey.includes("_indication_")) {
			console.log("Automatic removed obsolete item:"+storageKey);
			removeValue(storageKey);
		}
	}
}

/**
 * Any changes synchronize with LocalStorageObject.java
 * */
function toStorageKey(elementId, rowObjectClass, primaryKey) {
	if (elementId !== null) {
		if (rowObjectClass === null) {
			rowObjectClass = "undefined";
		}
		if (primaryKey === null) {
			primaryKey = "0";
		}
		//return rowObjectClass+"_"+elementId+"_"+primaryKey;
		return AS_PREFIX+rowObjectClass+"."+primaryKey+"."+elementId;
	}
	return null;
}

function removeValue(storageKey) {
	//console.log("removing key:"+storageKey);
	if (storageKey!==null) {
		localStorage.removeItem(storageKey);
	}
}

function storeValue(storageKey, value) {
	if (storageKey!==null) {
		const objectValue = {timestamp: Date.now(), data: value };
		localStorage.setItem(storageKey, JSON.stringify(objectValue));
		console.log("saving:"+storageKey);// - "+JSON.stringify(objectValue));
	}
}

function getValue(storageKey) {
	if (storageKey!==null) {
		let value = localStorage.getItem(storageKey);
		if (value) {
			const objectValue = JSON.parse(value);
			if (objectValue && objectValue.data) {
				return objectValue;
			}
		}
	}
	return null;
}

function checkLocalValue(elementId, storageKey, timestamp) {
	let savedValue = getValue(storageKey);
	let actualValue = CKEDITOR.instances[elementId].getData();
	if (savedValue !== null && savedValue.timestamp>timestamp) {
		console.log("Found valid saved data, check content");
		if (removeEmptyLine(savedValue.data)!==removeEmptyLine(actualValue)) {
			/*console.log("1:"+removeEmptyLine(savedValue)+":1");
			console.log("2:"+removeEmptyLine(actualValue)+":2");*/
			doConfirmDialog(storageKey,elementId,savedValue.data);
		}
		//console.log("timestamp from db:"+timestamp);
		//console.log("savedValue timestamp:"+savedValue.timestamp);
	}
}

function removeEmptyLine(text) {
  return text.trim().replace(/(\r?\n)\s*\1+/g, '$1');
}

function save(storageKey, elementId)
{
	let value = CKEDITOR.instances[elementId].getData();
	storeValue(storageKey,value);
}

function doConfirmDialog(storageKey, elementId, savedValue) {
	var retVal = confirm(msg("confirm.recoveryData"));
	if( retVal === true ) {
		CKEDITOR.instances[elementId].setData(savedValue);
		//console.log("Restored data from localsession");
	}
	removeValue(storageKey);
};
